import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=7b8b9399&scoped=true"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=7b8b9399&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8b9399",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8b9399')) {
      api.createRecord('7b8b9399', component.options)
    } else {
      api.reload('7b8b9399', component.options)
    }
    module.hot.accept("./DeptRoleUserModal.vue?vue&type=template&id=7b8b9399&scoped=true", function () {
      api.rerender('7b8b9399', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DeptRoleUserModal.vue"
export default component.exports